import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { applyTheme, getInitialTheme, THEMES, toggleTheme as toggle } from './theme';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [themeName, setThemeName] = useState(() => getInitialTheme());

  useEffect(() => {
    applyTheme(themeName);
  }, [themeName]);

  const setTheme = useCallback((next) => {
    if (THEMES[next]) setThemeName(next);
  }, []);

  const toggleTheme = useCallback(() => {
    setThemeName((current) => toggle(current));
  }, []);

  const value = useMemo(
    () => ({
      theme: THEMES[themeName],
      themeName,
      setTheme,
      toggleTheme,
      isDark: themeName === 'dark',
    }),
    [themeName, setTheme, toggleTheme]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme debe usarse dentro de <ThemeProvider>');
  return ctx;
}